<template>
  <div>
    <!-- <div class="progress" style="margin-bottom: 10px;">
        <div class="bar" :style="'height:30px;background:#97f380;width:' + progress() + '%'"></div>
    </div> -->
    <vue-dropzone :id="id" ref="FileUploaded" class="dropzone" :options="dropzoneOptions" :include-styling="false" 
                  :duplicateCheck="true" :useCustomSlot="true" 
                  @vdropzone-file-added="getFile" 
                  @vdropzone-files-added="getFiles" 
                  @vdropzone-success-multiple="onSuccess" 
                  @vdropzone-queue-complete="OnAllFileUploaded" 
                  @vdropzone-removed-file="removeThisFile">
      <div class="dropzone-custom-content">
        <i class="fa fa-cloud-upload fa-3x"></i>
        <h3 class="dropzone-custom-title">Drag & drop Files Here OR</h3>
        <div class="subtitle">Upload From Computer</div>
        <div> <button class="btn btn-seconadry" @click.prevent>Browse</button></div>
        <div class="subtitle"><i>File Size is limited to 250 MB</i> </div>
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import sheetJSConfig from "@/configs/sheetJS.js";
import apiutil from "@/services/apiUtil.js";


export default {
    name: "BaseDropzone",
    mixins: [apiutil],
    components: {
        vueDropzone: vue2Dropzone
    },
    props: ["id", "File", "UploadType","acceptedFileTypes"],
    data: function () {
        return {
            dropzoneOptions: {
               url: `${process.env.VUE_APP_dropZonePostUrl}`,
                thumbnailWidth: 150,
                maxFilesize: 250,
                addRemoveLinks: true,
                uploadMultiple: true,
                maxFiles: this.UploadType.AllowMultiple == true ? 15 : 1,
                headers: {
                    "My-Awesome-Header": "header value"
                },
                acceptedFiles:this.acceptedFileTypes?this.acceptedFileTypes:sheetJSConfig.DocUploadType,
                 init: function() 
                       {
                         this.on("addedfiles", function(files) 
                         {
                             console.log(` ADDEDFILES   ADDEDFILES   ADDEDFILES   ADDEDFILES   ADDEDFILES   ADDEDFILES   `,files)
                              return;
                     
                         });
                         this.on("sending", function(file,xhr, formData){
                             formData.append("uploadType","Initial Issuance");
                             return;
                         });
                         this.on("success", function(file, response){
                               console.log(` SUCCESS   SUCCESS   SUCCESS   SUCCESS   SUCCESS   SUCCESS   file `,file)
                                        console.log(` SUCCESS   SUCCESS   SUCCESS   SUCCESS   SUCCESS   SUCCESS   response `,response)
                                      //  this.$emit('handleTmpUploadResponse',response);
                                      return;
                         });
                    
            }
            },
            fileLength:0,
            files:0
        }
    },
    computed: {
       $eumAuth: function(){
       return this.$root.$eumAuth;
     }
    },
    created() {
       
        this._setVmInApiUtil(this.$root);


    },
    methods: {
        progress(){
            console.log("rest");
            return this.files / this.fileLength * 100
        },
       // tokenPromise = new Promise(this.$eumAuth.acquireIdToken),
        getFile(e) {
            let self = this;
            console.log('updated getFile running');
      
             let tkn = null;
             let isValid = this.$store.getters['authModule/apiTokenIsValid'];
            if (isValid) {
             tkn = this.$store.getters['authModule/api_idtoken'];
            
            } else {
              // User() will try to silently get a new token  
              this.$eumAuth.User(false)
              .then(function(resp){
                 if (resp) {
                     console.log('was able to get a new token silently');
                     tkn = resp.apiIdToken;
                 }
              },
              function(respfail){
                  // if no token was acquired silently they will have to login
                    // completely logout and force login
                    console.log('Unable to silently acquire token, must login');
                    this.$store.dispatch("authModule/LogoutUser");
              });
            }
            
            this.$refs.FileUploaded.setOption('headers',{Authorization:`Bearer ${tkn}`});
               // console.log(`token: ${tkn}`)
                this.fileLength = 0;
                this.files = 0;
                console.log('getFile', e)
    
        },
        getFiles(e) {
            
              let tkn = null;
             let isValid = this.$store.getters['authModule/apiTokenIsValid'];
            if (isValid) {
             tkn = this.$store.getters['authModule/api_idtoken'];
            
            }
            this.$refs.FileUploaded.setOption('headers',{Authorization:`Bearer ${tkn}`})
            console.log('getFiles', e)
            this.fileLength = e.length;
        },
        onSuccess(file, response, e) {
            //debugger;
            console.log("onSucess", file)
            this.files += file.length;
            this.File.UploadFile = file;
            this.$emit("change", e);
            // if(this.fileLength == this.files)
            //     this.$Progress.finish();

        },
        OnAllFileUploaded() {
            console.log(`OnAllFileUploaded()......`);
            if (this.UploadType.AllowMultiple == true) {
                let Rejectedfiles=this.$refs.FileUploaded.dropzone.getRejectedFiles();
                if(Rejectedfiles)
                {
                    if(Rejectedfiles.length>0)
                    {
                        this._AlertPopup("File(s) uploaded can be of type .doc,.docx,.xlx,.xlsx,.xlsm,.ppt,.pptx,.pdf,.zip,.txt"+ "\n and "+
                        "File size should not exceed 250 MB.","error");
                    }
                }
               
                this.$refs.FileUploaded.dropzone.removeAllFiles();
                this.$forceUpdate();
            }
        },
        removeThisFile(file, error, xhr, e) {
              console.log(`removeThisFile()......`,file);
            if (this.UploadType.AllowMultiple != true) {
                console.log('going to emit remove for e =>',e);
                this.$emit("Remove", e);

            }
        },

    }
};

</script>

<style>
.dropzone {
    border: 2px dashed #bbb;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    padding: 25px;
    text-align: center;
    font-size: 16px;
    color: #646464;
    height: 300px !important;
    padding-top: 50px !important;
}
.vue-dropzone i {
    color: #646464 !important;
}
</style>
